import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { ForwardedCostWarningsProps } from "models/propTypes/invoicePropTypes";
//#endregion
//#region components
import { StaticInfoMessage } from "components/common";
import { Grid } from "@mui/material";
//#endregion
import { InvoiceWarningHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

// One banner for every cancelled source document: a section carries at most one banner, and each line names its
// own document in the server's words. It sits outside "Skicka som" because it is about the rows, whatever the
// send method.
const ForwardedCostWarnings: React.FC<ForwardedCostWarningsProps> = ({ warnings }) => {
  const forwardedCostWarnings = InvoiceWarningHelper.getForwardedCostWarnings(warnings);
  if (forwardedCostWarnings.length === 0) return null;

  return (
    <Grid item container className={cssExports.forwardedCostWarnings}>
      <StaticInfoMessage displayType={StyleEnums.DisplayType.Warning}>
        <Grid container direction="column" rowGap={1}>
          {forwardedCostWarnings.map((warning, index) => (
            <Grid item key={index}>
              {warning.message}
            </Grid>
          ))}
        </Grid>
      </StaticInfoMessage>
    </Grid>
  );
};

export default ForwardedCostWarnings;
